
import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CardModule } from 'primeng/card';
import { Controller } from '../../../services/controller';
import { ControllerList } from './controller-list/controller-list';

@Component({
  selector: 'app-landing',
  imports: [CardModule, ControllerList],
  templateUrl: './landing.html',
  styleUrl: './landing.css',
})
export class Landing implements OnInit {
  controllerService = inject(Controller);

  constructor(private titleService: Title) {
    titleService.setTitle('Controller list');
  }

  ngOnInit(): void {
    this.controllerService.getControllerList();
  }
}
